import {Box} from '@mui/material';
import './ProtocolIntelligenceContent.scss';
import UploadProtocol from './uploadProtocol/UploadProtocol';
import GenerateArtifacts from './generateArtifacts/GenerateArtifacts';
import {useReviewHeaderContext} from '../../header/ReviewHeader';

const ProtocolIntelligenceContent = () => {
  const {fileName, isFileSubmitted} = useReviewHeaderContext();

  const toggleGenerateArtifacts = fileName || isFileSubmitted;

  return (
    <Box className="manage-protocol-content-body">
      {toggleGenerateArtifacts ? <GenerateArtifacts /> : <UploadProtocol />}
    </Box>
  );
};

export default ProtocolIntelligenceContent;
